<template>
  <!-- element-loading-text="excle导入中，请稍等" -->
  <div class="app-container">
    <!-- 编辑弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%">
      <el-form
        ref="addForm"
        label-position="right"
        :model="addForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="id" prop="text" v-if="addForm._id">
          <el-input v-model="addForm._id" :disabled="!!addForm._id"></el-input>
        </el-form-item>
        <el-form-item label="属性名称" prop="text">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="isShow">
          <el-switch v-model="addForm.isShow" active-text="显示" inactive-text="不显示"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogConfirmButtonClick('addForm')">确 定</el-button>
        <el-button type="primary" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-card class="box-card" v-loading="loading" element-loading-spinner="el-icon-loading">
      <div slot="header" class="clearfix">
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-circle-plus-outline"
          round
          :style="{float:'right',marginTop:'10px'}"
          @click="addItem"
        >新增</el-button>
      </div>
      <div class="content">
        <el-table :data="tdata" border style="width: 100%">
          <el-table-column prop="name" label="属性名称" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <el-tag>{{scope.row.isShow?'显示':'隐藏'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="220" class="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="handleEdit(scope.row)" size="mini">编辑</el-button>
              <el-button type="danger" @click="handleDelete(scope.row)" size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import * as api from "../../api/share.api";
import axios from "axios";
import { constants } from "crypto";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "新增",
      formLabelWidth: "200",
      editorContent: "",
      defaultForm: {
        name: null,
        isShow: true
      },
      addForm: {},
      loading: false,
      rules: {
        name: [
          {
            required: true,
            message: "请完善信息",
            trigger: "blur"
          }
        ]
      },
      tdata: []
    };
  },
  components: {
    VueEditor
  },
  created() {
    this.initData();
  },
  mounted() {},
  computed: {},
  methods: {
    handleUpload(file, fileList) {
      this.fileList2.push({
        name: file.data,
        url: file.data
      });
    },
    handleRemove(file, fileList) {
      this.fileList2 = this.fileList2.filter(v => v.url != file.url);
    },
    addItem() {
      this.dialogVisible = true;
      this.dialogTitle = "新增";
      this.addForm = this.defaultForm;
    },
    handleEdit(item) {
      this.dialogVisible = true;
      this.dialogTitle = "修改";
      this.addForm = item;
    },
    dialogConfirmButtonClick(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return this.$message.error("请检查填写信息是否完整");
        }
        if (this.addForm._id) {
          this.httpPost("/backend/packageTag/upd", this.addForm).then(resp => {
            this.addForm = this.defaultForm;
            if (resp.code == 0) {
              this.$message.success("修改成功", 1000);
              this.initData();
              this.dialogVisible = false;
            } else {
              this.$message.error(resp.msg, 2000);
            }
          });
        } else {
          this.httpPost("/backend/packageTag/add", this.addForm).then(resp => {
            this.addForm = this.defaultForm;
            if (resp.code == 0) {
              this.$message.success("添加成功", 1000);
              this.initData();
              this.dialogVisible = false;
            } else {
              this.$message.error(resp.msg, 2000);
            }
          });
        }
      });
    },
    initData() {
      this.loading = true;
      this.httpPost("/backend/packageTag", {}).then(resp => {
        console.log(resp);
        this.loading = false;
        this.tdata = resp.data;
      });
    },

    onEditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        console.log(valid);
        if (valid) {
          api.updateShareDataById(this.form).then(resp => {
            if (resp.rCode != 0) {
              this.$message.error(resp.msg);
            } else {
              this.dialogVisible = false;
              this.form = {};
              this.$message.success("修改成功");
              this.initData();
            }
          });
          console.log(this.form);
        } else {
          this.$message.error("请检查填写信息是否完整");
          return false;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSizeblur(size) {
      this.pquery.size = size;
    },
    handleCurrentblur(page) {
      this.pquery.page = page;
    },
    handleClick(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm("请再次确认是否删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          this.httpPost("/backend/packageTag/del", { _id: row._id }).then(
            resp => {
              if (resp.code != 0) {
                this.$message.error("删除失败");
              } else {
                this.initData();
                this.$message.success("删除成功");
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.cell {
  text-align: center;
}
</style>

